import { render, staticRenderFns } from "./product-sale-countdown.vue?vue&type=template&id=24e72f1e&scoped=true"
import script from "./product-sale-countdown.vue?vue&type=script&lang=js"
export * from "./product-sale-countdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e72f1e",
  null
  
)

export default component.exports